import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

export interface FcmMessage {
  fcmMessageId: string;
  notification: { title: string; body: string; image?: string };
  data: any;
}

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  private _fcmToken: string;
  private _messages$ = new Subject<FcmMessage>();

  constructor(private afMessaging: AngularFireMessaging) {}

  public setToken(val: string) {
    this._fcmToken = val;
  }

  public get token() {
    return this._fcmToken || '';
  }

  public get messages() {
    return this._messages$.asObservable();
  }

  public initListener() {
    this.afMessaging.messages
      .pipe(
        map((msg: any) => {
          const notificationData = msg.data?.notification
            ? JSON.parse(msg.data.notification)
            : null;
          const notificationPayload = msg.data?.payload ? JSON.parse(msg.data.payload) : null;
          return {
            data: notificationPayload,
            notification: notificationData,
            fcmMessageId: msg.fcmMessageId,
          } as FcmMessage;
        })
      )
      .subscribe((res) => {
        this._messages$.next(res);
      });
  }
}
